// React
import React from 'react';
import { Button, Modal, ModalHeader, Label, Col, Input } from 'reactstrap';

// Containers Injection
import {
  SelectInput,
  convertEventSelectToTarget,
} from '../../../../../../containers/componentsInjection';

export const ModalProviderSpecialty = ({
  id,
  isOpen,
  toggle,
  options,
  validation,
  handleBack,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      centered
    >
      <ModalHeader>
        {id ? 'Editar Especialidade' : 'Adicionar Especialidade'}
      </ModalHeader>
      <div className="modal-body">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit(e);
          }}
        >
          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="selectInput" className="form-label">
                Tipo de Especialidade
              </Label>
              <SelectInput
                options={options || []}
                value={validation.values.selectInput}
                onChange={(event) => {
                  validation.handleChange(
                    convertEventSelectToTarget('selectInput', event)
                  );
                }}
                onBlur={(event) => {
                  validation.handleBlur(
                    convertEventSelectToTarget('selectInput', event)
                  );
                }}
                inputId="selectInput"
                invalid={
                  !!(
                    validation.touched.selectInput &&
                    validation.errors.selectInput
                  )
                }
              />
            </div>
          </Col>

          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="benefitsInput" className="form-label">
                Benefícios
              </Label>
              <Input
                id="benefitsInput"
                aria-multiline
                type="textarea"
                className="form-control"
                style={{
                  height: 100,
                }}
                value={validation.values.benefitsInput}
                onBlur={validation.handleBlur}
                onChange={(e) => validation.handleChange(e)}
              />
            </div>
          </Col>
          <div className="text-end">
            <button
              type="button"
              className="btn btn-link"
              onClick={() => {
                handleBack();
                validation.resetForm();
              }}
            >
              Cancelar
            </button>
            <Button color="primary" type="submit">
              Salvar
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
